export default __webpack_public_path__ + "static/media/cameraportrait.22e8087d.jpg";